"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.general.title': 'Configuración General',
    'settings.general.description': 'Configure los ajustes de su aplicación e integraciones',
    'settings.general.tabs.googleDrive': 'Google Drive',
    'settings.general.tabs.general': 'General',
    'settings.general.tabs.apiKeys': 'Claves API',
    'settings.general.tabs.rag': 'Configuración RAG',
    'settings.general.tabs.credit': 'Configuración de Créditos',
    'settings.general.tabs.socialMedia': 'Redes Sociales',
    'settings.general.generalSettings.comingSoon': 'La configuración general estará disponible pronto.',
    'settings.general.apiKeys.comingSoon': 'La gestión de claves API estará disponible pronto.',
    'settings.general.chatLearning.title': 'Resumen de Aprendizaje del Chat',
    'settings.general.chatLearning.description': 'Gestione su resumen de aprendizaje personalizado de IA. Esta información ayuda a la IA a proporcionar respuestas mejores y más adaptadas.',
    'settings.general.chatLearning.summaryLabel': 'Resumen de Aprendizaje',
    'settings.general.chatLearning.summaryPlaceholder': 'Ingrese o edite información sobre sus preferencias, contexto y detalles importantes que deberían ayudar a la IA a asistirle mejor...',
    'settings.general.chatLearning.summaryHelp': 'Este resumen se actualiza automáticamente basándose en sus conversaciones. Puede editarlo manualmente para incluir preferencias específicas o contexto.',
    'settings.general.save': 'Guardar Configuración',
    'settings.general.reload': 'Recargar',
    'settings.general.savedSuccessfully': 'Configuración general guardada exitosamente',
    'settings.general.failedToSave': 'Error al guardar la configuración general',
    'settings.general.failedToLoad': 'Error al cargar la configuración general',
};
